module.exports = __webpack_public_path__ + "static/lewandowski_main_41-dc7c02684cb19ff3ccd5a8438e0b7fda.png";